import { RouteObject } from "react-router";
import { Navigate } from "react-router-dom";

import { AdminProtected } from "@/app/application/AdminProtected";
import PageError from "@/shared/ui/errors/PageError";
import * as Sentry from "@sentry/react";

export const CommonRoutes: RouteObject[] = [
	{
		path: "NewCompetenceResource",
		element: <Navigate to="/competency/resource/new" replace />,
	},
	{
		path: "NewCompetencyResource",
		element: <Navigate to="/competency/resource/new" replace />,
	},
	{
		path: "LiveSettings",
		element: <Navigate to="/live" replace />,
	},
	{
		path: "updatedprocedures",
		lazy: async () => {
			const { ShowUpdatedProcedures: ShowUpdatedProcedures } =
				await import("@/features/procedures/pages/updated-procedures-page/UpdatedProceduresPage");
			return {
				Component: () => (
					<Sentry.ErrorBoundary
						fallback={(boundary) => (
							<PageError
								error={boundary.error}
								componentStack={boundary.componentStack}
								reset={() => boundary.resetError()}
							/>
						)}
					>
						<ShowUpdatedProcedures />
					</Sentry.ErrorBoundary>
				),
			};
		},
	},
	{
		path: "showdocumentsused/*",
		children: [
			{
				index: true,
				lazy: async () => {
					const { ShowDocumentsUsed } =
						await import("@/features/procedures/ui/components/procedures/ShowDocumentsUsed");
					return {
						Component: () => (
							<Sentry.ErrorBoundary
								fallback={(boundary) => (
									<PageError
										error={boundary.error}
										componentStack={boundary.componentStack}
										reset={() => boundary.resetError()}
									/>
								)}
							>
								<ShowDocumentsUsed />
							</Sentry.ErrorBoundary>
						),
					};
				},
			},
			{
				path: ":id",
				lazy: async () => {
					const { ShowDocumentsUsed } =
						await import("@/features/procedures/ui/components/procedures/ShowDocumentsUsed");
					return {
						Component: () => (
							<Sentry.ErrorBoundary
								fallback={(boundary) => (
									<PageError
										error={boundary.error}
										componentStack={boundary.componentStack}
										reset={() => boundary.resetError()}
									/>
								)}
							>
								<ShowDocumentsUsed />
							</Sentry.ErrorBoundary>
						),
					};
				},
			},
		],
	},
	{
		path: "updatedprocedures",
		lazy: async () => {
			const { ShowUpdatedProcedures: ShowUpdatedProcedures } =
				await import("@/features/procedures/pages/updated-procedures-page/UpdatedProceduresPage");
			return {
				Component: () => (
					<Sentry.ErrorBoundary
						fallback={(boundary) => (
							<PageError
								error={boundary.error}
								componentStack={boundary.componentStack}
								reset={() => boundary.resetError()}
							/>
						)}
					>
						<ShowUpdatedProcedures />
					</Sentry.ErrorBoundary>
				),
			};
		},
	},
	{
		path: "admin/dashboard",
		lazy: async () => {
			const { AdminDashboard } =
				await import("@/components/admin/admin-dashboard/components/AdminDashboard");
			return {
				Component: () => (
					<Sentry.ErrorBoundary
						fallback={(boundary) => (
							<PageError
								error={boundary.error}
								componentStack={boundary.componentStack}
								reset={() => boundary.resetError()}
							/>
						)}
					>
						<AdminProtected>
							<AdminDashboard />
						</AdminProtected>
					</Sentry.ErrorBoundary>
				),
			};
		},
	},
];
